// Build Your Own Pack - Cart Handler
document.addEventListener('DOMContentLoaded', function() {
  const sectionEl = document.querySelector('[data-section-type="build-your-own-pack"]');
  if (!sectionEl) return;

  const sectionId = sectionEl.dataset.sectionId;
  const bag1Select = document.getElementById(`BYOPBag1-${sectionId}`);
  const bag2Select = document.getElementById(`BYOPBag2-${sectionId}`);
  const bag3Select = document.getElementById(`BYOPBag3-${sectionId}`);
  const totalPriceEl = document.getElementById(`byop-total-price-display-${sectionId}`);
  const addToCartBtn = document.getElementById(`byop-add-to-cart-${sectionId}`);
  const subscriptionToggle = document.getElementById(`byop-subscription-toggle-${sectionId}-input`);
  const progressContainer = document.getElementById(`byop-progress-container-${sectionId}`);
  const progressFill = document.getElementById(`byop-progress-fill-${sectionId}`);
  const progressAmount = document.getElementById(`byop-progress-amount-${sectionId}`);
  const progressMessage = document.getElementById(`byop-progress-message-${sectionId}`);
  const celebration = document.getElementById(`byop-celebration-${sectionId}`);
  const imageEl = document.getElementById(`byop-featured-image-${sectionId}`);
  
  if (!bag1Select || !bag2Select || !bag3Select || !totalPriceEl || !addToCartBtn) return;

  // Get settings from button data attributes
  const MINIMUM_BAGS = parseInt(addToCartBtn.dataset.minimumBags) || 3;
  const FREE_DELIVERY_THRESHOLD = parseInt(addToCartBtn.dataset.freeDeliveryThreshold) || 3000; // £30 in pence
  
  let hasShownCelebration = false;

  // Get products data
  const productsJsonEl = document.getElementById(`BYOPProductsJson-${sectionId}`);
  const products = productsJsonEl ? JSON.parse(productsJsonEl.textContent) : [];

  let selectedProducts = [];
  let sellingPlanId = null;

  // Handle subscription toggle
  if (subscriptionToggle) {
    subscriptionToggle.addEventListener('change', function() {
      if (this.checked) {
        // Show progress bar
        if (progressContainer) {
          progressContainer.style.display = 'block';
        }
        updateProgressBar();
      } else {
        // Hide progress bar
        if (progressContainer) {
          progressContainer.style.display = 'none';
        }
        // Hide celebration if visible
        if (celebration) {
          celebration.classList.remove('show');
          hasShownCelebration = false;
        }
      }
      updateAddToCartButton();
    });
  }

  // Update progress bar
  function updateProgressBar() {
    if (!progressContainer || !subscriptionToggle || !subscriptionToggle.checked) {
      return;
    }

    const total = selectedProducts.reduce((sum, product) => sum + product.price, 0);
    const percentage = Math.min((total / FREE_DELIVERY_THRESHOLD) * 100, 100);
    
    // Update progress fill
    if (progressFill) {
      progressFill.style.width = percentage + '%';
    }
    
    // Update amount display
    if (progressAmount) {
      const totalFormatted = (total / 100).toFixed(2);
      const thresholdFormatted = (FREE_DELIVERY_THRESHOLD / 100).toFixed(2);
      progressAmount.textContent = `£${totalFormatted} / £${thresholdFormatted}`;
    }
    
    // Update message
    if (progressMessage) {
      if (total >= FREE_DELIVERY_THRESHOLD) {
        progressMessage.textContent = '🎉 You\'ve unlocked FREE delivery!';
        progressMessage.classList.add('achieved');
        
        // Show celebration if not already shown
        if (celebration && !hasShownCelebration) {
          celebration.classList.add('show');
          hasShownCelebration = true;
          
          // Auto-hide celebration after 2 seconds
          setTimeout(function() {
            celebration.classList.remove('show');
          }, 2000);
        }
      } else {
        const remaining = ((FREE_DELIVERY_THRESHOLD - total) / 100).toFixed(2);
        progressMessage.textContent = `Add £${remaining} more to unlock free delivery!`;
        progressMessage.classList.remove('achieved');
        
        // Hide celebration if total drops below threshold
        if (celebration && hasShownCelebration && total < FREE_DELIVERY_THRESHOLD) {
          celebration.classList.remove('show');
          hasShownCelebration = false;
        }
      }
    }
  }

  // Get selected product from dropdown
  function getProductFromSelect(selectEl) {
    if (!selectEl || !selectEl.value) return null;
    
    const productId = parseInt(selectEl.value);
    const selectedOption = selectEl.options[selectEl.selectedIndex];
    const variantId = parseInt(selectedOption.dataset.variantId);
    const price = parseInt(selectedOption.dataset.price);
    const title = selectedOption.dataset.title;
    const image = selectedOption.dataset.image;
    
    return {
      productId: productId,
      variantId: variantId,
      price: price,
      title: title,
      image: image
    };
  }

  // Update selected products array
  function updateSelectedProducts() {
    selectedProducts = [];
    
    const bag1 = getProductFromSelect(bag1Select);
    const bag2 = getProductFromSelect(bag2Select);
    const bag3 = getProductFromSelect(bag3Select);
    
    if (bag1) selectedProducts.push(bag1);
    if (bag2) selectedProducts.push(bag2);
    if (bag3) selectedProducts.push(bag3);
    
    updateTotal();
    updateImage();
    updateProgressBar();
    updateAddToCartButton();
  }

  // Update total price
  function updateTotal() {
    const total = selectedProducts.reduce((sum, product) => sum + product.price, 0);
    if (totalPriceEl) {
      totalPriceEl.textContent = `£${(total / 100).toFixed(2)}`;
    }
  }

  // Update product image
  function updateImage() {
    if (!imageEl) return;
    
    const yogaGifUrl = 'https://cdn.shopify.com/s/files/1/0041/7782/1785/files/Yoga_pug.gif?v=1614310601';
    
    // Show first selected bag's image, or default
    if (selectedProducts.length > 0 && selectedProducts[0].image) {
      const imageUrl = selectedProducts[0].image;
      // Update src and srcset for responsive images
      imageEl.src = imageUrl;
      imageEl.srcset = imageUrl.replace('800x800', '600x600') + ' 600w, ' +
                       imageUrl + ' 800w, ' +
                       imageUrl.replace('800x800', '1000x1000') + ' 1000w, ' +
                       imageUrl.replace('800x800', '1200x1200') + ' 1200w';
      imageEl.sizes = '(min-width: 768px) 50vw, 100vw';
      imageEl.alt = selectedProducts[0].title;
      imageEl.style.display = 'block';
      imageEl.style.visibility = 'visible';
      imageEl.style.opacity = '1';
    } else if (products.length > 0 && products[0].featured_image) {
      imageEl.src = products[0].featured_image;
      imageEl.alt = 'Build Your Own Pack';
      imageEl.style.display = 'block';
      imageEl.style.visibility = 'visible';
      imageEl.style.opacity = '1';
    } else {
      // Fallback to yoga gif if no product images available
      imageEl.src = yogaGifUrl;
      imageEl.removeAttribute('srcset');
      imageEl.removeAttribute('sizes');
      imageEl.alt = 'Build Your Own Pack';
      imageEl.style.display = 'block';
      imageEl.style.visibility = 'visible';
      imageEl.style.opacity = '1';
    }
  }

  // Update add to cart button state
  function updateAddToCartButton() {
    const hasMinimumBags = selectedProducts.length >= MINIMUM_BAGS;
    const isSubscribed = subscriptionToggle ? subscriptionToggle.checked : false;
    
    if (hasMinimumBags && isSubscribed) {
      addToCartBtn.disabled = false;
      addToCartBtn.querySelector('#AddToCartText-' + sectionId).textContent = 'Subscribe & Add to Cart';
    } else if (hasMinimumBags && !isSubscribed) {
      addToCartBtn.disabled = false;
      addToCartBtn.querySelector('#AddToCartText-' + sectionId).textContent = 'Add to Cart (One-time)';
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.querySelector('#AddToCartText-' + sectionId).textContent = `Select ${MINIMUM_BAGS} bags to continue`;
    }
  }

  // Handle dropdown changes
  [bag1Select, bag2Select, bag3Select].forEach(function(selectEl) {
    if (selectEl) {
      selectEl.addEventListener('change', function() {
        updateSelectedProducts();
      });
    }
  });

  // Add to cart handler
  addToCartBtn.addEventListener('click', async function() {
    if (selectedProducts.length < MINIMUM_BAGS) {
      alert(`Please select at least ${MINIMUM_BAGS} bags`);
      return;
    }

    const isSubscribed = subscriptionToggle ? subscriptionToggle.checked : false;
    
    // Get selling plan ID from ReCharge widget
    const planInput = document.querySelector('input[name="selling_plan"]');
    const planSelect = document.querySelector('select[name="selling_plan"]');
    const planId = planInput ? planInput.value : (planSelect ? planSelect.value : null);

    if (isSubscribed && !planId) {
      alert('Please select a delivery frequency');
      return;
    }

    // Disable button
    const originalText = addToCartBtn.querySelector('#AddToCartText-' + sectionId).textContent;
    addToCartBtn.disabled = true;
    addToCartBtn.querySelector('#AddToCartText-' + sectionId).textContent = 'Adding...';

    try {
      // Add each product to cart sequentially
      for (let i = 0; i < selectedProducts.length; i++) {
        const product = selectedProducts[i];
        const formData = {
          id: product.variantId,
          quantity: 1
        };

        if (isSubscribed && planId) {
          formData.selling_plan = planId;
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Cart API error:', errorText);
          throw new Error(`Failed to add ${product.title}: ${response.status}`);
        }

        const data = await response.json();
        console.log(`Added ${product.title} to cart:`, data);
      }

      // Update cart count
      await updateCartCount();

      // Navigate to cart
      setTimeout(function() {
        window.location.href = '/cart';
      }, 300);

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error adding products to cart. Please try again.');
      addToCartBtn.disabled = false;
      addToCartBtn.querySelector('#AddToCartText-' + sectionId).textContent = originalText;
    }
  });

  // Update cart count badge
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartLink = document.querySelector('.site-header__cart');
      
      if (cartLink) {
        let cartCountEl = document.getElementById('CartCount');
        if (cart.item_count > 0) {
          if (!cartCountEl) {
            cartCountEl = document.createElement('div');
            cartCountEl.id = 'CartCount';
            cartCountEl.className = 'site-header__cart-count';
            cartLink.appendChild(cartCountEl);
          }
          let countSpan = cartCountEl.querySelector('span');
          if (!countSpan) {
            countSpan = document.createElement('span');
            cartCountEl.appendChild(countSpan);
          }
          countSpan.textContent = cart.item_count;
          cartCountEl.style.display = 'flex';
        }
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  // Initialize subscription widget
  function initSubscription() {
    setTimeout(function() {
      const rcToggle = document.getElementById('rc_purchase_type_autodeliver');
      const planSelect = document.querySelector('select[name="selling_plan"]');
      
      if (rcToggle) {
        rcToggle.addEventListener('change', function() {
          updateAddToCartButton();
        });
      }

      if (planSelect) {
        planSelect.addEventListener('change', function() {
          sellingPlanId = this.value;
          updateAddToCartButton();
        });
      }
      
      updateAddToCartButton();
    }, 500);
  }

  // Close celebration on click
  if (celebration) {
    celebration.addEventListener('click', function(e) {
      if (e.target === celebration) {
        celebration.classList.remove('show');
      }
    });
  }

  // Initialize
  initSubscription();
  updateSelectedProducts();
  updateAddToCartButton();
});

